module.exports = __webpack_public_path__ + "static/media/app-test.e0af93dd.png";